// Subtle Maharashtra-inspired line-art motifs. Contemporary, understated — not festival-poster.

export function SahyadriDivider({ className = "", color = "#C69A4B" }) {
  return (
    <svg className={className} viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 70 L180 30 L300 55 L460 18 L620 50 L800 22 L980 52 L1150 26 L1300 48 L1440 30"
            stroke={color} strokeWidth="1.5" strokeOpacity="0.5" fill="none" />
      <path d="M0 78 L200 48 L360 68 L520 40 L700 66 L900 44 L1080 66 L1260 46 L1440 62"
            stroke={color} strokeWidth="1" strokeOpacity="0.25" fill="none" />
    </svg>
  );
}

// Warli-inspired human figure row (line art), used as a slim decorative band.
export function WarliBand({ className = "", color = "#C86128" }) {
  const fig = (x) => (
    <g key={x} stroke={color} strokeWidth="1.4" strokeLinecap="round" fill="none" opacity="0.55">
      <circle cx={x} cy="10" r="3.4" />
      <path d={`M${x} 13 L${x} 26`} />
      <path d={`M${x - 7} 17 L${x} 20 L${x + 7} 17`} />
      <path d={`M${x} 26 L${x - 6} 36 M${x} 26 L${x + 6} 36`} />
    </g>
  );
  const figs = [];
  for (let x = 20; x < 1440; x += 46) figs.push(fig(x));
  return (
    <svg className={className} viewBox="0 0 1440 44" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      {figs}
    </svg>
  );
}

// Small ornament used beside section overlines.
export function DiamondRule({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} aria-hidden="true">
      <span className="h-px w-8 bg-gold/60" />
      <span className="h-1.5 w-1.5 rotate-45 bg-saffron" />
      <span className="h-px w-8 bg-gold/60" />
    </span>
  );
}
